var _a;
import { createTheme } from '@material-ui/core';
var regularWoff2 = '../assets/fonts/NeutrifStudioRegular.woff2';
var semiBoldWoff2 = '../assets/fonts/NeutrifStudioSemiBold.woff2';
var boldWoff2 = '../assets/fonts/NeutrifStudioBold.woff2';
var neutrifStudioRegular = {
    fontFamily: 'Neutrif Studio',
    fontStyle: 'normal',
    fontWeight: 400,
    src: "\n    local('Neutrif Studio Regular'),\n    local('NeutrifStudio-Regular'),\n    url('" + regularWoff2 + "') format('woff2')\n  ",
};
var neutrifStudioSemiBold = {
    fontFamily: 'Neutrif Studio',
    fontStyle: 'normal',
    fontWeight: 600,
    src: "\n    local('Neutrif Studio Regular'),\n    local('NeutrifStudio-Regular'),\n    url('" + semiBoldWoff2 + "') format('woff2')\n  ",
};
var neutrifStudioBold = {
    fontFamily: 'Neutrif Studio',
    fontStyle: 'normal',
    fontWeight: 700,
    src: "\n    local('Neutrif Studio Bold'),\n    local('NeutrifStudio-Bold'),\n    url('" + boldWoff2 + "') format('woff2')\n  ",
};
var theme = createTheme({
    palette: {
        primary: {
            main: 'hsl(253, 100%, 56%);',
            light: 'hsl(253 100% calc(56% + var(--lighten)));',
            dark: 'hsl(242, 88%, 40%);',
            contrastText: 'hsl(var(--blanco-h), var(--blanco-s), var(--blanco-l))',
        },
        secondary: {
            main: 'hsl(60, 100%, 61%)',
            light: 'hsl(60, 100%, calc(61% + var(--lighten)))',
            dark: 'hsl(60, 100%, calc(61% + var(--darken)))',
            contrastText: 'hsl(var(--blanco-h), var(--blanco-s), var(--blanco-l))',
        },
        error: {
            main: 'hsl(349, 100%, 35%)',
            light: 'hsl(349, 100%, calc(35% + var(--lighten)))',
            dark: 'hsl(349 100% calc(35% + var(--darken)))',
            contrastText: 'hsl(var(--blanco-h), var(--blanco-s), var(--blanco-l))',
        },
        warning: {
            main: 'hsl(var(--primario-morado-h), var(--primario-morado-s), var(--primario-morado-l));',
            light: 'hsl(var(--primario-morado-h), var(--primario-morado-s), calc(var(--primario-morado-l) + var(--lighten)));',
            dark: 'hsl(var(--primario-morado-h), var(--primario-morado-s), calc(var(--primario-morado-l) + var(--darken)));',
            contrastText: 'hsl(var(--blanco-h), var(--blanco-s), var(--blanco-l))',
        },
        info: {
            main: 'hsl(230, 17%, 43%)',
            light: 'hsl(230, 17%, calc(43% + var(--lighten)))',
            dark: 'hsl(230, 17%, calc(43% + var(--darken)))',
            contrastText: 'hsl(var(--blanco-h), var(--blanco-s), var(--blanco-l))',
        },
        success: {
            main: 'hsl(156, 87%, 42%);',
            light: 'hsl(156, 87%, calc(42% + var(--lighten)));',
            dark: 'hsl(156, 87%, calc(42% + var(--darken)));',
            contrastText: 'hsl(var(--blanco-h), var(--blanco-s), var(--blanco-l))',
        },
    },
    shape: {
        borderRadius: 4,
    },
    typography: {
        fontFamily: 'var(--main-font)',
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [neutrifStudioRegular, neutrifStudioBold, neutrifStudioSemiBold],
            },
        },
        MuiButton: {
            root: {
                borderRadius: '40px',
                height: '3.125rem',
                boxShadow: 'unset',
                fontFamily: 'var(--main-font)',
                fontWeight: 600,
                fontSize: '1rem',
                lineHeight: 1.5,
                textTransform: 'unset',
                padding: '0 2rem',
            },
            outlined: {
                border: '2px solid hsl(var(--valor-gris-l43), 0.6)',
                color: 'hsl(var(--valor-gris-l43), 0.6)',
                padding: '0 2rem',
                backgroundColor: 'transparent',
                '&:hover': {
                    border: '2px solid transparent',
                    backgroundColor: 'transparent',
                },
            },
            outlinedPrimary: {
                borderWidth: '2px',
                border: '2px solid var(--primario-morado)',
                padding: '0 2rem',
                '&:hover': {
                    border: '2px solid var(--primario-morado)',
                    backgroundColor: 'var(--hover-secundary)',
                },
            },
            contained: {
                border: '2px solid transparent',
                boxShadow: 'unset',
                padding: '0 2rem',
                '&:disabled': {
                    color: 'var(--disabled-text-button)',
                    backgroundColor: 'var(--disabled-background-button)',
                },
                '&:hover': {
                    boxShadow: 'unset',
                    '@media (hover: none)': {
                        boxShadow: 'unset',
                    },
                },
            },
            containedPrimary: {
                border: '2px solid transparent',
                boxShadow: 'unset',
                padding: '0 2rem',
                '&:hover': {
                    border: '2px solid var(--hover-primary)',
                    color: 'var(--blanco)',
                    backgroundColor: 'var(--hover-primary)',
                    '@media (hover: none)': {
                        color: 'var(--blanco)',
                    },
                },
            },
        },
        MuiInputBase: {
            input: {
                color: 'var(--gris-l3)',
            },
        },
        MuiFormLabel: {
            root: {
                color: 'hsl(var(--valor-gris-l43), 0.6)',
            },
        },
        MuiStepper: {
            root: {
                padding: 'unset',
                backgroundColor: 'unset',
            },
        },
        MuiSnackbar: {
            root: {
                boxShadow: 'unset',
                borderRadius: 10,
            },
        },
        MuiStepIcon: {
            root: {
                color: 'var(--primario-morado)',
                '&$completed': {
                    color: 'var(--primario-morado)',
                    backgroundColor: 'var(--primario-neon)',
                    borderRadius: '50%',
                },
                '&$active': {
                    color: 'var(--primario-morado)',
                },
            },
        },
    },
});
theme.typography.h1 = (_a = {
        fontSize: '1.375rem',
        lineHeight: 1.5,
        color: 'var(--text1)'
    },
    _a[theme.breakpoints.down('sm')] = {
        fontSize: '1.125rem',
    },
    _a);
theme.typography.h2 = {
    fontSize: '1.125rem',
    lineHeight: 1.5,
    color: 'var(--text1)',
};
theme.typography.h3 = {
    fontSize: '1rem',
    lineHeight: 1.5,
    color: 'var(--text1)',
};
export default theme;
